import * as yup from 'yup';

import { emailValidationSchema } from 'src/constants/validation';

import { InviteFormFields } from '../types';

export const inviteFormValidationSchema = yup.object({
  [InviteFormFields.emails]: yup
    .array()
    .of(yup.string().required('Required'))
    .test({
      name: 'check-valid-emails',
      test: (value, ctx) => {
        const invalidEmails =
          value?.filter(email => !emailValidationSchema.isValidSync(email)) ?? [];

        if (invalidEmails.length > 0) {
          return ctx.createError({
            message: `Some emails are invalid: ${invalidEmails.join(', ')}`,
          });
        }

        return true;
      },
    })
    .nullable()
    .min(1, 'Field must have at least 1 item')
    .required('Required'),
});
